import * as yup from 'yup';

import { emailRequiredValidator } from '@mopla/utils';

export const EmailValidationSchema = yup.object().shape({
	email: emailRequiredValidator(),
});
